export default "__VITE_ASSET__B_Cc27E8__"